import React,{useState} from 'react';
import Footer from '../components/Footer';
import LuxRoomPage from '../components/LuxRoom';
// import Navbar2 from '../components/Navbar2';
import Navbar from '../components/Navbar';

import Sidebar from '../components/Sidebar';


function LuxRoom() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />  
           <LuxRoomPage />
           <Footer />
        </div>
    )
}

export default LuxRoom
